<div class="_flex _gap-1 _items-center">
    <div class="_tooltip">
        <form [formGroup]="consumerViewToggleForm">
            <app-form-toggle-switch
                [checked]="consumerView"
                [fieldId]="fieldId">
            </app-form-toggle-switch>
        </form>
        <span class="_tooltiptext _tooltip-inline-left">{{ consumerView ? 'Disable' : 'Enable' }} consumer view</span>
    </div>
</div>

